<div class="cad-dialog">
  <header class="cad-dialog__header">
    <div class="cad-dialog__title">
      <i class="bi bi-file-earmark-ruled"></i>
      <span [title]="data.drawing.original_name">{{ data.drawing.original_name }}</span>
    </div>
    <div class="cad-dialog__actions">
      <button
        *ngIf="data.onDownload; else directDownload"
        type="button"
        class="cad-dialog__btn"
        (click)="data.onDownload()"
        title="Download original"
        aria-label="Download original"
      >
        <i class="bi bi-download"></i>
      </button>
      <ng-template #directDownload>
        <a class="cad-dialog__btn" [href]="data.drawing.file_url" target="_blank" rel="noopener" download title="Download original">
          <i class="bi bi-download"></i>
        </a>
      </ng-template>
      <button type="button" class="cad-dialog__btn" (click)="close()" title="Close" aria-label="Close">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>
  </header>

  <div class="cad-dialog__body">
    <app-cad-viewer-canvas [drawing]="data.drawing" [downloadHandler]="data.onDownload ?? null"></app-cad-viewer-canvas>
  </div>
</div>
